import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function NewFaq() {
  const data=[
    {
      id:"q1",
      ques:"1. O que são Fichas?",
      ans:"As Fichas são a sua moeda no jogo usada para jogar partidas de pôquer e torneios. Você pode reivindicá-las diariamente e por hora (a cada 60 minutos) e também pode obtê-las assistindo anúncios ou completando tarefas."
    },
    {
      id:"q2",
      ques:"2. Fiquei sem Fichas. O que faço?",
      ans:"Você pode reivindicar fichas diariamente e por hora (a cada 60 minutos). Você também pode ganhar mais assistindo anúncios ou completando tarefas de recompensa."
    },
    {
      id:"q3",
      ques:"3. O que são Pontos de Recompensa?",
      ans:"Os Pontos de Recompensa são obtidos jogando — ao se classificar nas tabelas de líderes, terminar em posições de pagamento em torneios ou completar tarefas. Você pode resgatá-los na Baazi Store por ofertas e cartões-presente das melhores marcas."
    },
    {
      id:"q4",
      ques:"4. Como ganho Pontos de Recompensa?",
      ans:"Jogue partidas, suba nas tabelas de líderes, complete tarefas diárias ou termine em posições de pagamento em torneios para ganhar Pontos de Recompensa."
    },
    {
      id:"q5",
      ques:"5. Como uso os Pontos de Recompensa?",
      ans:"Abra a Baazi Store no app, escolha sua oferta ou cupom preferido e resgate usando seus Pontos de Recompensa disponíveis."
    },
    {
      id:"q6",
      ques:"6. Posso resgatar os Pontos de Recompensa por dinheiro?",
      ans:"Não. Os Pontos de Recompensa só podem ser usados para resgatar ofertas ou cupons na Baazi Store."
    },
    {
      id:"q7",
      ques:"7. Resgatei meus Pontos de Recompensa mas não recebi o item.",
      ans:"Por favor, aguarde até 48 horas para o processamento. Se não receber, entre em contato com o Suporte com o nome da recompensa e a data do resgate para obter ajuda."
    },
    {
      id:"q8",
      ques:"8. Posso transferir Fichas ou Pontos de Recompensa para outro jogador?",
      ans:"Não. Tanto as Fichas quanto os Pontos de Recompensa não são transferíveis e estão vinculados apenas à sua conta."
    },
    {
      id:"q9",
      ques:"9. Onde posso ver meus saldos?",
      ans:"Você pode ver suas Fichas e Pontos de Recompensa na seção de Carteira do app a qualquer momento."
    },
    {
      id:"q10",
      ques:"10. Meu saldo ainda não foi atualizado. O que faço?",
      ans:"Atualize o app ou saia e faça login novamente. Se o problema persistir, entre em contato com o Suporte com seu nome de usuário e os detalhes do jogo."
    },

  ]
  return (
    <div>
      <Topheader colorbox="newfaq_header_color" title="Perguntas Frequentes" />
      <div className="main-container mb-5 mt-4 ">

        <div className={style.btm_safe}>
          <div id="accordion">
            {data.map((item,index)=>{
          return(
            <div key={index} className={`${style.box}`}>
            <div className={`${style.accordionHeader} collapsed`} data-bs-toggle="collapse" href={`#${item.id}`}>
              <div className={style.title_box}>
                <span className={style.title}>{item.ques}</span>
                <svg className={style.arrowIcon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M12.0002 7L8.00051 11L4.00025 7" stroke="#041B67" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>


            <div id={item.id} className='collapse mt-2' data-bs-parent="#accordion">
              <div className={style.desc}>
                {item.ans}
              </div>
            </div>
            </div>
             )
        })}
          </div>
        </div>



      </div>

      <div className={style.btm_fixed_area}>
        <div className={style.btn}>
         <a href='mailto:playerrelations@pokerbaazi.com' target='_blank' rel="noreferrer" style={{color:'white'}}>Fale Conosco</a>

        </div>

      </div>
    </div>
  )
}
